export enum WeightUSMetric {
  GramUS = 'weightMetricGramUS',
  KiloGramUS = 'weightMetricKiloGramUS',
  TonneUS = 'weightMetricTonneUS',
  KiloTonneUS = 'weightMetricKiloTonneUS',
  MegaTonneUS = 'weightMetricMegaTonneUS',
  GigaTonneUS = 'weightMetricGigaTonneUS',
}
